import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="comment-form"
export default class extends Controller {
  static targets = ["button", "form"];

  connect() {
    // Make sure form is hidden initially
    this.hideForm();
  }

  showForm() {
    this.buttonTarget.classList.add("hidden");
    this.formTarget.classList.remove("hidden");

    // Focus on the textarea after showing the form
    const textarea = this.formTarget.querySelector("textarea");
    if (textarea) {
      setTimeout(() => {
        textarea.focus();
      }, 100); // Small delay to ensure the form is visible
    }
  }

  hideForm() {
    this.buttonTarget.classList.remove("hidden");
    this.formTarget.classList.add("hidden");

    // Clear the form when hiding it
    this.clearForm();
  }

  clearForm() {
    const form = this.formTarget.querySelector("form");
    if (form) {
      const textarea = form.querySelector("textarea");
      const spoilerCheckbox = form.querySelector(
        "input[name='review[spoiler]']"
      );

      if (textarea) textarea.value = "";
      if (spoilerCheckbox) spoilerCheckbox.checked = false;

      // Reset character counter if present
      const characterCounterElement = this.formTarget.querySelector(
        "[data-controller*='character-counter']"
      );
      if (characterCounterElement) {
        const counter = characterCounterElement.querySelector(
          "[data-character-counter-target='counter']"
        );
        if (counter) counter.textContent = "0/5000";
      }
    }
  }

  handleSubmitEnd(event) {
    // Check if the form submission was successful by looking for errors
    const formElement = event.target;
    const hasErrors = formElement.querySelector(
      '.text-red-200, .text-red-400, [data-character-counter-target="warning"]:not(.hidden)'
    );

    // If no errors are visible, assume success and hide the form
    if (!hasErrors) {
      setTimeout(() => {
        this.hideForm();
      }, 500); // Small delay to allow Turbo Stream to update the page
    }
  }
}
